export const Styles:any = {
  ar: [],
  en: [],
};
